// --- COMPONENT: CATEGORIES CARD ---
// File: /components/CategoryCard.jsx

const CategoryCard = ({ km, img, elevation, cutOff, link }) => (
  <div className="flex flex-col h-full overflow-hidden text-black transition-transform duration-300 bg-white shadow-xl group hover:-translate-y-2">
    <div className="relative h-40 overflow-hidden">
      <img src={img} alt={`${km} KM`} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110" />
      <div className="absolute bottom-0 left-0 bg-[#DFFF00] px-3 py-1 font-bold text-black text-sm tracking-tighter">
        {km} KM
      </div>
    </div>
    <div className="flex flex-col justify-between flex-1 p-5">
      <div>
        <div className="flex justify-between pb-2 mb-4 border-b border-gray-200">
          <div className="text-center">
            <p className="text-[10px] uppercase text-gray-500 font-bold">Distance</p>
            <p className="text-xl font-black">{km} KM</p>
          </div>
        </div>
      </div>

      {
        km > 30 && (
          <a
            href="https://wa.me/6285179903676"
            target="_blank"
            className="w-full bg-[#DFFF00] hover:bg-[#cbe600] mb-2 text-black font-bold py-2 px-4 text-xs uppercase tracking-widest transition-colors mt-auto text-center"
          >
            Check Qualifications
          </a>
        )
      }

      <a
        href={link}
        target="_blank"
        className="w-full bg-[#DFFF00] hover:bg-[#cbe600] text-black font-bold py-2 px-4 text-xs uppercase tracking-widest transition-colors mt-auto text-center"
      >
        Register
      </a>

    </div>
  </div>
);

export default CategoryCard;